document.addEventListener('DOMContentLoaded', function() {
    
  // Custom ProductForm class for Algolia elements
  class AlgoliaProductForm extends HTMLElement {
      constructor() {
          super();
      }
  
      connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form) return;
          
          this.variantIdInput = this.form.querySelector('[name=id]');
          if (this.variantIdInput) {
              this.variantIdInput.disabled = false;
          }
          
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
      }
  
      onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
          if (this.submitButton) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.classList.add('loading');
          }
          
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
      
          // Use the same config as DAWN's product-form.js
          let config;
          if (typeof fetchConfig === 'function') {
              config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type']; // Let browser set it for FormData
          } else {
              // Fallback if fetchConfig not available
              config = {
                  method: 'POST',
                  headers: {
                      'X-Requested-With': 'XMLHttpRequest'
                  }
              };
          }
      
          const formData = new FormData(this.form);
      
          if (this.cart) {
              formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
              formData.append('sections_url', window.location.pathname);
              this.cart.setActiveElement(document.activeElement);
          }
      
          config.body = formData;
      
          // Use routes global if available
          const cartUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      
          fetch(cartUrl, config)
              .then((response) => response.json())
              .then((response) => {
                  if (response.status) {
                      this.handleErrorMessage(response.description);
      
                      const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                      if (!soldOutMessage) return;
                      this.submitButton.setAttribute('aria-disabled', true);
                      this.submitButtonText.classList.add('hidden');
                      soldOutMessage.classList.remove('hidden');
                      this.error = true;
                      return;
                  } else if (!this.cart) {
                      window.location = (window.routes && window.routes.cart_url) || '/cart';
                      return;
                  }
      
                  this.error = false;
                  const quickAddModal = this.closest('quick-add-modal');
                  if (quickAddModal) {
                      document.body.addEventListener(
                          'modalClosed',
                          () => {
                              setTimeout(() => {
                                  this.cart.renderContents(response);
                              });
                          },
                          { once: true }
                      );
                      quickAddModal.hide(true);
                  } else {
                      this.cart.renderContents(response);
                  }
              })
              .catch((e) => {
                  console.error(e);
                  this.handleErrorMessage('Unable to add to cart');
              })
              .finally(() => {
                  this.submitButton.classList.remove('loading');
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                  if (spinner) spinner.classList.add('hidden');
              });
      }
  
      handleErrorMessage(errorMessage = false) {
          this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
          if (!this.errorMessageWrapper) return;
          this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
          if (errorMessage) {
              this.errorMessage.textContent = errorMessage;
          }
      }
  }

  // Custom QuickAddModal class for Algolia elements  
  class AlgoliaQuickAddModal extends HTMLElement {
      constructor() {
          super();
          
          // Add event listeners like DAWN's ModalDialog
          this.addEventListener('click', (event) => {
              if (event.target === this) this.hide();
          });
          
          this.addEventListener('keyup', (event) => {
              if (event.code.toUpperCase() === 'ESCAPE') this.hide();
          });
      }

      connectedCallback() {
          // Auto-move to body like DAWN's ModalDialog
          if (this.moved) return;
          this.moved = true;
          
          // Find the closest section for dataset (similar to DAWN)
          const section = this.closest('.shopify-section');
          if (section) {
              this.dataset.section = section.id.replace('shopify-section-', '');
          }
          
          document.body.appendChild(this);
          
          // Initialize modal content area
          this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
          
          // Add close button listener
          const closeBtn = this.querySelector('[id^="ModalClose-"]');
          if (closeBtn) {
              closeBtn.addEventListener('click', () => this.hide());
          }
      }

      show(opener) {
          if (!opener) return;
          
          this.openedBy = opener;
          
          opener.setAttribute('aria-disabled', true);
          opener.classList.add('loading');
          const spinner = opener.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
      
          fetch(opener.getAttribute('data-product-url'))
              .then((response) => response.text())
              .then((responseText) => {
                  const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
                  const productElement = responseHTML.querySelector('product-info');
                  
                  if (productElement && this.modalContent) {
                      this.preprocessHTML(productElement);
                      
                      // Use DAWN's HTMLUpdateUtility instead of innerHTML
                      if (window.HTMLUpdateUtility) {
                          HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
                      } else {
                          this.modalContent.innerHTML = productElement.outerHTML;
                      }
                      
                      // CRITICAL: Call initialization after content is set
                      setTimeout(() => {
                          this.initializeModalElements();
                      }, 50);
                  }
                  
                  document.body.classList.add('overflow-hidden');
                  this.setAttribute('open', '');
                  
                  if (window.Shopify && Shopify.PaymentButton) {
                      Shopify.PaymentButton.init();
                  }
                  if (window.ProductModel) window.ProductModel.loadShopifyXR();
                  
                  if (window.trapFocus) {
                      window.trapFocus(this, this.querySelector('[role="dialog"]'));
                  }
              })
              .finally(() => {
                  opener.removeAttribute('aria-disabled');
                  opener.classList.remove('loading');
                  if (spinner) spinner.classList.add('hidden');
              });
      }
      
      // Add the preprocessing method from DAWN's QuickAddModal
      preprocessHTML(productElement) {
          productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                  this.modalContent.classList.add(classApplied);
          });
          this.preventDuplicatedIDs(productElement);
          this.removeDOMElements(productElement);
          this.updateImageSizes(productElement);
          this.preventVariantURLSwitching(productElement);
      }
      
      preventVariantURLSwitching(productElement) {
          productElement.setAttribute('data-update-url', 'false');
      }
      
      preventDuplicatedIDs(productElement) {
          const sectionId = productElement.dataset.section;
          const oldId = sectionId;
          const newId = `quickadd-${sectionId}`;
          productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
          Array.from(productElement.attributes).forEach((attribute) => {
              if (attribute.value.includes(oldId)) {
                  productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
              }
          });
          productElement.dataset.originalSection = sectionId;
      }
      
      removeDOMElements(productElement) {
          const pickupAvailability = productElement.querySelector('pickup-availability');
          if (pickupAvailability) pickupAvailability.remove();
      
          const productModal = productElement.querySelector('product-modal');
          if (productModal) productModal.remove();
      
          const modalDialog = productElement.querySelectorAll('modal-dialog');
          if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }
      
      updateImageSizes(productElement) {
          const product = productElement.querySelector('.product');
          const desktopColumns = product?.classList.contains('product--columns');
          if (!desktopColumns) return;
      
          const mediaImages = product.querySelectorAll('.product__media img');
          if (!mediaImages.length) return;
      
          let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
          if (product.classList.contains('product--medium')) {
              mediaImageSizes = mediaImageSizes.replace('715px', '605px');
          } else if (product.classList.contains('product--small')) {
              mediaImageSizes = mediaImageSizes.replace('715px', '495px');
          }
      
          mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
      
      initializeModalElements() {
          // Initialize product forms with cart drawer behavior
          const productForms = this.modalContent.querySelectorAll('product-form');
          productForms.forEach(form => {
              if (customElements.get('product-form')) {
                  customElements.upgrade(form);
                  
                  // Override form submission to close modal after cart update
                  const originalSubmitHandler = form.onSubmitHandler;
                  if (originalSubmitHandler) {
                      form.onSubmitHandler = (evt) => {
                          const result = originalSubmitHandler.call(form, evt);
                          
                          // Close modal after successful cart addition
                          document.body.addEventListener('modalClosed', () => {
                              this.hide(true);
                          }, { once: true });
                          
                          return result;
                      };
                  }
              }
          });
          
          // Initialize other components
          const variantSelects = this.modalContent.querySelector('variant-selects');
          if (variantSelects && customElements.get('variant-selects')) {
              customElements.upgrade(variantSelects);
          }
          
          const productInfo = this.modalContent.querySelector('product-info');
          if (productInfo && customElements.get('product-info')) {
              customElements.upgrade(productInfo);
          }
          
          const sliders = this.modalContent.querySelectorAll('slider-component');
          sliders.forEach(slider => {
              if (customElements.get('slider-component')) {
                  customElements.upgrade(slider);
              }
          });
      }

      hide(preventFocus = false) {
          document.body.classList.remove('overflow-hidden');
          document.body.dispatchEvent(new CustomEvent('modalClosed'));
          this.removeAttribute('open');
          
          if (this.modalContent) {
              this.modalContent.innerHTML = '';
          }
          
          // Remove focus trap like DAWN
          if (window.removeTrapFocus && this.openedBy && !preventFocus) {
              window.removeTrapFocus(this.openedBy);
          }
          
          if (window.pauseAllMedia) {
              window.pauseAllMedia();
          }
      }
  }

  // Define custom elements only once
  if (!customElements.get('algolia-product-form')) {
      customElements.define('algolia-product-form', AlgoliaProductForm);
  }
  if (!customElements.get('quick-add-modal')) {
      customElements.define('quick-add-modal', AlgoliaQuickAddModal);
  }

  // Function to initialize event listeners
  function initializeAlgoliaElements() {
      console.log('Initializing Algolia elements...');
      
      // document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      // hideCurrentProductSlide(current_product_handle);
      // Handle modal openers (modals auto-move to body via connectedCallback)
      document.querySelectorAll('.uic-HorizontalSlider-list modal-opener:not([data-algolia-ready])').forEach(opener => {
          opener.setAttribute('data-algolia-ready', 'true');
          
          const button = opener.querySelector('button');
          // alert('1')
          if (button) {
              button.addEventListener('click', function(e) {
                  e.preventDefault();
                  const modalId = opener.getAttribute('data-modal');
                  const modal = document.querySelector(modalId);
                  if (modal && modal.show) {
                      modal.show(button);
                  }
              });
          }
      });
  }

  // Event listeners
  const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      mutations.forEach(mutation => {
          if (mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach(node => {
                  if (node.nodeType === 1 && // Element node
                      (node.classList?.contains('uic-HorizontalSlider-container') || 
                      node.querySelector?.('.cart-notification__recommendationsr') ||
                      node.matches?.('[data-quickshop-full]') ||
                      node.querySelector?.('[data-quickshop-full]'))) {
                      shouldReinit = true;
                  }
              });
          }
      });
      
      if (shouldReinit) {
          setTimeout(initializeAlgoliaElements, 100);
      }
  });

  // Observe multiple potential containers - fix this part
  const containers = [
      document.querySelector('.cart-notification__recommendations'),
      document.querySelector('#recommendations'),
      document.querySelector('[data-section-type="product-recommendations"]'),
      document.body // fallback
  ].filter(Boolean);

  containers.forEach(container => {
      observer.observe(container, { childList: true, subtree: true });    
  });
  
  setTimeout(initializeAlgoliaElements, 1500);
});